module.exports = __webpack_public_path__ + "img/ring_y_s_0_1@2x.70fe6266.png";